module.exports = __webpack_public_path__ + "static/media/instagram.d0434859.svg";